export function setupGlobalEvents() {
  // to avoid the problem with outdated chunks during deployment
  window.addEventListener("vite:preloadError", () => {
    window.location.reload();
  });
}
